export default function ($rootScope, $scope, $http, $q, $timeout, $stateParams, $state, $firebaseObject, $uibModal, CONFIG, FirebaseFactory, UtilitiesFactory) {
    'ngInject';

    let idUser = $stateParams.id;
    let utilities = UtilitiesFactory.getUtilities();

    $scope.hidden = !!!idUser;
    $scope.isProgress = false;
    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;
    $scope.error = '';
    $scope.regions = $rootScope.allRegions;
    $scope.user = {};

    $rootScope.$broadcast('selectionMenu', {context: ''});
    /***
     *
     */
    let init = () => {
        $scope.isProgress = true;
        let ref = FirebaseFactory.getUser(idUser);
        let obj = $firebaseObject(ref);

        obj.$loaded().then( () => {
            $scope.isProgress = false;
            $scope.user = obj;
        });
    };

    /***
     * Submit
     */
    $scope.submit = () => {
        let keys = $scope.user.hasOwnProperty('permissions') ? Object.keys($scope.user.permissions) : [];
        let activePermissions = _.filter(keys, (key) => { return $scope.user.permissions[key] === true});
        $scope.user.permissions = {};

        _.forEach(activePermissions, (permission) => {
            $scope.user.permissions[permission] = true;
        });

        $scope.isProgress = true;
        $scope.user.uid = idUser;
        FirebaseFactory.saveUser($scope.user);
        $state.reload();
    };

    /***
     * Reset
     */
    $scope.reset = () => {
        init();
    };

    init();
}



// WEBPACK FOOTER //
// ./src/app/views/app.user/appUsersCtrl.js